var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".al{fill:none;}.al,.am{stroke-width:0px;}.an{clip-path:url(#b);}.am{fill:#00269a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 56,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "an"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "am",
    d: "M.757,7.157h1.349l2.417,3.063v-3.063h1.346v5.168h-1.387l-2.375-3.083v3.083H.757v-5.168Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "am",
    d: "M10.426,10.821c.276-.284.418-.654.418-1.107,0-.418-.142-.769-.425-1.052-.283-.284-.641-.425-1.066-.425-.432,0-.783.148-1.066.432-.277.284-.418.648-.418,1.086s.135.796.412,1.08c.269.276.627.418,1.065.418s.796-.142,1.08-.432M7.309,11.725c-.54-.526-.803-1.188-.803-1.99,0-.809.277-1.477.837-2.004.546-.507,1.214-.762,2.017-.762s1.484.263,2.031.789c.546.52.816,1.168.816,1.93,0,.823-.277,1.504-.83,2.044-.546.52-1.221.783-2.024.783-.831,0-1.511-.263-2.044-.79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    className: "am",
    d: "M14.695,9.485c.466,0,.695-.216.695-.648s-.222-.648-.681-.648h-.42v1.296h.407ZM12.941,7.157h2.058c.513,0,.924.142,1.255.418.337.297.513.695.513,1.201,0,.715-.297,1.188-.891,1.411l1.383,2.138h-1.613l-1.086-1.822h-.272v1.822h-1.347v-5.168Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l",
    className: "am",
    d: "M18.522,8.505h-1.094v-1.348h3.535v1.348h-1.094v3.821h-1.347v-3.821Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    className: "am",
    d: "M21.814,7.157h1.347v1.826h1.892v-1.826h1.348v5.169h-1.348v-1.994h-1.892v1.994h-1.347v-5.169Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "am",
    d: "M29.162,9.485c.465,0,.695-.216.695-.648s-.222-.648-.682-.648h-.42v1.296h.407ZM27.408,7.157h2.058c.513,0,.924.142,1.255.418.337.297.513.695.513,1.201,0,.715-.297,1.188-.89,1.411l1.383,2.138h-1.613l-1.086-1.822h-.272v1.822h-1.347v-5.168Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "am",
    d: "M35.84,10.821c.276-.284.418-.654.418-1.107,0-.418-.142-.769-.425-1.052-.283-.284-.641-.425-1.066-.425-.431,0-.783.148-1.066.432-.276.284-.418.648-.418,1.086s.135.796.412,1.08c.269.276.628.418,1.066.418s.796-.142,1.08-.432M32.724,11.725c-.541-.526-.804-1.188-.804-1.99,0-.809.277-1.477.837-2.004.546-.507,1.214-.762,2.017-.762s1.484.263,2.03.789c.546.52.817,1.168.817,1.93,0,.823-.277,1.504-.83,2.044-.546.52-1.222.783-2.025.783-.83,0-1.511-.263-2.043-.79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "am",
    d: "M40.258,9.532c.533,0,.796-.23.796-.695,0-.445-.256-.661-.783-.661h-.46v1.356h.447ZM38.463,7.157h2.308c.499,0,.904.161,1.194.499.291.31.432.728.432,1.235,0,.486-.141.877-.432,1.173-.283.304-.674.459-1.154.459h-1v1.801h-1.348v-5.168Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "am",
    d: "M7.261,18.242c-.499-.526-.756-1.188-.756-1.977,0-.776.256-1.43.756-1.964.519-.546,1.16-.816,1.93-.816,1.039,0,1.814.432,2.334,1.295l-1.079.594c-.027-.068-.082-.142-.163-.23-.289-.324-.661-.486-1.106-.486s-.776.175-.998.519c-.189.29-.284.668-.284,1.141,0,.479.115.85.338,1.127.243.304.601.452,1.066.452.27,0,.52-.088.743-.256.242-.183.378-.398.405-.661h-1.187v-1.08h2.59v.284c0,.877-.216,1.565-.655,2.064-.459.52-1.12.783-1.99.783-.789,0-1.436-.263-1.943-.79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "am",
    d: "M14.405,16.002c.465,0,.695-.216.695-.648s-.222-.648-.682-.648h-.42v1.296h.407ZM12.651,13.674h2.058c.513,0,.924.142,1.255.418.338.297.513.695.513,1.201,0,.715-.297,1.188-.89,1.411l1.383,2.138h-1.613l-1.086-1.822h-.272v1.822h-1.347v-5.168Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "am",
    d: "M18.117,18.579c-.459-.344-.695-.816-.695-1.41v-3.495h1.349v3.212c0,.621.31.931.932.931.276,0,.514-.074.677-.223.168-.155.256-.371.256-.641v-3.279h1.348v3.347c0,.654-.223,1.16-.675,1.525-.411.324-.957.486-1.633.486-.621,0-1.14-.148-1.558-.452"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "am",
    d: "M25.992,16.345l1.707-2.671h1.348v5.169h-1.346v-3.033h-.002l-1.343,2.108h-.715l-1.35-2.108h-.002v3.033h-1.351v-5.169h1.351l1.704,2.671Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "am",
    d: "M33.21,16.345l1.706-2.671h1.349v5.169h-1.346v-3.033h-.002l-1.343,2.108h-.715l-1.35-2.108h-.005v3.033h-1.348v-5.169h1.35l1.705,2.671Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "am",
    d: "M40.169,16.845l-.546-1.579-.553,1.579h1.1ZM38.869,13.674h1.543l1.916,5.169h-1.458l-.351-.958h-1.787l-.345.958h-1.438l1.919-5.169Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "am",
    d: "M43.071,13.674h1.35l2.377,3.063v-3.063h1.347v5.169h-1.35l-2.375-3.084v3.084h-1.349v-5.169Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "am",
    d: "M43.071,7.157v1.349h10.823v10.336h1.349V7.157h-12.171Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload6);
export default __webpack_public_path__ + "static/media/download6.dfcdd97c65b507d8d1f4933497c1e807.svg";
export { ForwardRef as ReactComponent };